<template>
    <div class="ovt__objects-configuration" :class="{hidden: !show}">
      <div class="ovt__objects-configuration__title" :class="{open: !show}" @click="toggleSelectObjectsPanel()">{{ $t.selectObjects }}</div>
      <div class="ovt__objects-configuration__title-vertical" :class="{open: !show, 'no-visibility': show}" @click="!show ? toggleSelectObjectsPanel() : null">{{ $t.selectObjects }}</div>
      <div class="ovt__objects-configuration__subtitle">
        <span class="ovt__select-label-flex">{{ $t.databaseObjects }}
          <Tooltip :tooltipText="$keys.tooltips.closeApproachesInOvt" position="bottom">
            <i class="icon-info" style="margin-left: 4px;"  />
          </Tooltip>
        </span>
      </div>
      <div class="ovt__objects-configuration__close" :class="{open: !show}" @click="toggleSelectObjectsPanel()">
        <span class="rotated-text hidden-text">HiddenLabelForLayout</span>
        <span class="rotated-text hidden-text">HiddenLabelForLayout</span>
        <span class="rotated-text hidden-text">HiddenLabelForLayout</span>
        <span class="rotated-text hidden-text">HiddenLabelForLayout</span>
        <span class="rotated-text hidden-text">HiddenLabelForLayout</span>
      </div>
      <OrbitObjectsTable :tool="tool" />
      <div class="ovt__select-wrapper">
        <div class="ovt__select" v-for="select in displaySelects" :key="select">
          <div class="ovt__select-label">
            <span class="ovt__select-label-flex">
              {{ $t[select.label] }} 
              <Tooltip v-if="select.tooltip" :tooltipText="$keys.tooltips.asteroidFamilyData" position="bottom">
                <i class="icon-info" style="margin-left: 4px;"  />
              </Tooltip>
            </span>
          </div>
          <OrbitMultiselect :select="select" />
        </div>
      </div>
      <OrbitRiskList />
      <OrbitParticlesSize v-show="showParticlesSize" />
      <SyntheticObjects :tool="tool"/>
      <FocusSelector tool="ovt"/>
    </div>
</template>

<script>
import VisualisationService from '@/services/visualisation.service'
import OrbitObjectsTable from '@/components/ovt/OrbitObjectsTable'
import OrbitMultiselect from '@/components/ovt/OrbitMultiselect'
import OrbitRiskList from '@/components/ovt/OrbitRiskList'
import OrbitParticlesSize from '@/components/ovt/OrbitParticlesSize'
import SyntheticObjects from '@/components/common/SyntheticObjects'
import FocusSelector from "@/components/common/FocusOnSelector"
import Tooltip from '@/components/common/Tooltip'

export default {
    name: 'OrbitObjectsConfiguration',
    components: {
        OrbitMultiselect,
        OrbitObjectsTable,
        OrbitRiskList,
        OrbitParticlesSize,
        SyntheticObjects,
        FocusSelector,
        Tooltip,
    },
    props: {
        tool: String
    },
    computed: {
        show() {
            return VisualisationService.getSelectObjectsShow();
        },
        displaySelects() {
            return VisualisationService.getSelects();
        },
        riskListChecked() {
            return VisualisationService.getRiskListChecked();
        },
        showParticlesSize() {
            if (this.riskListChecked) {
                return true;
            }

            const activeSelects = VisualisationService.getOrbitVisualisationSelects() || {};
            const selects = this.displaySelects ? Object.values(this.displaySelects) : [];

            return selects.some(select => {
                const selectedOptions = activeSelects[select.id];
                return Array.isArray(selectedOptions) && selectedOptions.length > 0;
            });
        }
    },
    methods: {
        toggleSelectObjectsPanel() {
            VisualisationService.setSelectObjectsShow(!this.show);
        }
    },

}
</script>

<style>
    .ovt__select-label-flex {
        display: flex;
        align-items: right;
    }
    
    .ovt__select-label-tooltip {
        margin-left: 10px;
    }
</style>
